import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    loading: string;
    errorMessage: string;
    successMessage: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            loading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateWorkspace.loading?c=1zi31uqmqcn1q", defaultMessage: "Creating Workspace" }));
                },
                enumerable: true,
                configurable: true
            },
            errorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateWorkspace.errorMessage?c=2ozombwk63h49", defaultMessage: "Couldn''t create Workspace" }));
                },
                enumerable: true,
                configurable: true
            },
            successMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateWorkspace.successMessage?c=cwcyys3qvowy", defaultMessage: "Workspace created" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
